import React from 'react';
import { CardTitle, CardBody, CardBodyGroup, CardBodyBold } from './styles';
import CONSTANTS from './constants';
import { region } from 'op-components';
import { Region } from 'shared-components/enums';
import moment from 'moment';
import { CurrentAppConfig } from 'op-pages/RO/Careplan/AppConfig';
import { Typography } from '@mui/material';

interface InsuranceType {
  expiryDate: string;
  payor: { name: string };
  policyNumber: string;
}
interface Props {
  name: string;
  patientDetails: {
    healthMedicareNumber: string;
    healthMedicareIrn: string;
    medicareExpiryRawMonth: string;
    medicareExpiryRawYear: string;
    insurances: InsuranceType[];
  };
}

const InsuranceCard = ({ name, patientDetails }: Props): JSX.Element => {
  const { healthMedicareNumber, healthMedicareIrn, medicareExpiryRawMonth, medicareExpiryRawYear, insurances } =
    patientDetails;
  const formattedExpiry = medicareExpiryRawMonth + '/' + medicareExpiryRawYear.slice(-2);
  const hasMedicareExpiry = medicareExpiryRawMonth && medicareExpiryRawYear;
  const hasMedicareNumber = healthMedicareNumber && healthMedicareIrn;
  const { MEDICARE_NO, MEDICARE_EXP, INSURANCE, EXPIRATION_DATE, INSURANCE_COMPANY } = CONSTANTS;
  const MedicareInfo = (
    <>
      <CardBodyGroup data-testid="otherInfoMedicareNo">
        <Typography variant="body2" color="text.secondary">
          {MEDICARE_NO}
        </Typography>
        <Typography variant="body2" color="text.primary">
          {hasMedicareNumber ? `${healthMedicareNumber} ${healthMedicareIrn}` : '-'}
        </Typography>
      </CardBodyGroup>
      <CardBodyGroup data-testid="otherInfoMedicareExp">
        <Typography variant="body2" color="text.secondary">
          {MEDICARE_EXP}
        </Typography>
        <Typography variant="body2" color="text.primary">
          {hasMedicareExpiry ? `${formattedExpiry}` : '-'}
        </Typography>
      </CardBodyGroup>
    </>
  );
  const InsuranceInfo = insurances.map((insurance: InsuranceType) => (
    <>
      <CardBodyGroup data-testid="insuranceCardInsuranceName">
        <Typography variant="body2" color="text.secondary">
          {INSURANCE_COMPANY}
        </Typography>
        <Typography variant="body2" color="text.primary">
          {insurance.payor?.name || '-'}
        </Typography>
      </CardBodyGroup>
      <CardBodyGroup data-testid="insuranceCardInsuranceNumber">
        <Typography variant="body2" color="text.secondary">
          {INSURANCE}
        </Typography>
        <Typography variant="body2" color="text.primary">
          {insurance.policyNumber || '-'}
        </Typography>
      </CardBodyGroup>
      <CardBodyGroup data-testid="insuranceCardInsuranceExpiry">
        <Typography variant="body2" color="text.secondary">
          {EXPIRATION_DATE}
        </Typography>
        <Typography variant="body2" color="text.primary">
          {insurance.expiryDate
            ? `${moment(new Date(insurance.expiryDate)).format(CurrentAppConfig.PatientCard.defaultDateFormat)}`
            : '-'}
        </Typography>
      </CardBodyGroup>
    </>
  ));
  return (
    <div data-testid="insuranceCard">
      <CardTitle>{name}</CardTitle>
      <CardBody>
        {region === Region.AU && MedicareInfo}
        {InsuranceInfo}
      </CardBody>
    </div>
  );
};

export default InsuranceCard;
